<div class="container">
<nav class="navbar navbar-expand-lg bg-body-tertiary">
  <div class="container-fluid header">
    <p class="navbar-brand"><b>Hi,</b> {{name}}</p>

    <div class="dropdown">
      <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
      Admin Menu
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
        <li><a class="dropdown-item" [routerLinkActive]="['active']"[routerLink]="['admin']">Connects</a></li>
        <li><a class="dropdown-item" [routerLinkActive]="['active']" [routerLink]="['church-list']" >Church List</a></li>
        <li><a class="dropdown-item" [routerLinkActive]="['active']" [routerLink]="['settings']" >Settings</a></li>
        <li><a class="dropdown-item" href="#" (click)="logOut()">Logout</a></li>
      </ul>
    </div>
  </div>
</nav>

<div class="modal" tabindex="-1" id="exampleModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title">Log Out</h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p class="fs-5 text-center">Do you want to logout?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
          No
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="logOut()"
          data-bs-dismiss="modal"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>
</div>